import { useNavigate, useLocation, useParams } from 'react-router-dom';
import PropertyBoundaryForm from '../components/PropertyBoundaryForm';
import './SetupRancher.css'; // reuse the same shell styles

function EditProperty() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { id }    = useParams();
  const property  = location.state?.property ?? null;

  const handleSave = (updatedProperty) => {
    navigate(`/property/${id}/edit/features`, {
      state: { property: { ...property, ...updatedProperty } },
    });
  };

  return (
    <div className="setup-rancher-page">
      <div className="setup-rancher-container">

        <div className="setup-rancher-header">
          <h1>Edit Property</h1>
          <p>Update your ranch or farm details and boundary.</p>
        </div>

        <PropertyBoundaryForm
          initialData={property}
          stepLabel="Edit: Step 1 of 2"
          saveLabel="Save & Continue"
          cancelLabel="Cancel"
          onSave={handleSave}
          onCancel={() => navigate('/dashboard')}
        />

      </div>
    </div>
  );
}

export default EditProperty;

